import { List } from 'immutable';
import { energyName } from '../Energy';

/**
 * Badges for an active Pokémon whose Weakness or Resistance an attack changed (Conversion 1 and 2). The server sends
 * only what an attack changed, so a face-down Pokémon never gives its own away.
 *
 * @param {Map} activePokemon with `converted_weakness` and `converted_resistance`
 * @returns {List<string>} like "Weak to Fighting", "Resists Fire"
 */
export function conversionBadges(activePokemon) {
  const badges = [];

  if (activePokemon.get('converted_weakness')) {
    badges.push(`Weak to ${energyName(activePokemon.get('converted_weakness'))}`);
  }
  if (activePokemon.get('converted_resistance')) {
    badges.push(`Resists ${energyName(activePokemon.get('converted_resistance'))}`);
  }

  return List(badges);
}
